<template>
    <v-app>
        <div class="app">
            <div class="hero_img">
                <div class="center">
                <img src="@/assets/udeevent/ue_1.png" class="ue_1 pt-32" ></div>
                <div class="pa-27">
                    <p>問卷題目如下：</p>
                    <p class="qt">Q1: EBM 於 1988 年創立，今年度為邁入第幾週年呢？</p>
                    <p class="at">35週年</p>
                    <p class="qt">Q2: EBM 目前的主推產品有哪些？</p>
                    <p class="at">FHR、UDE、MobiPACS及AgileRIS</p>
                    <p class="qt">Q3: 請問下列醫院中，哪些已使用了 EBM 的產品？</p>
                    <p class="at">台大醫院、振興醫院、花蓮慈濟醫院</p>
                    <p class="qt">Q4: EBM 近期完成上線的是哪個案子呢？</p>
                    <p class="at">2021台大Main-PACS系統汰換案</p>
                    <p class="qt">Q5: 請問下列哪個圖像是 EBM 的新商標？</p>
                    <img src="@/assets/udeevent/ue_ebm_logo.png" width="93px" class="ue_1 pt-32" >
                    <p class="qt">Q6: 請問下列哪個是 EBM 總公司正確的地址？</p>
                    <p class="at">台北市內湖區內湖路一段516號</p>
                    <p class="qt">Q7: EBM 的股票代號是？</p>
                    <p class="at">8409</p>
                    <p class="qt">Q8: EBM 主要的業務範疇為？</p>
                    <p class="at">醫療影像系統(PACS)、行動醫療、電子病歷、影像自動判讀與醫療雲之研發與銷售</p>
                    <p class="qt">Q9: EBM 最新產品”行動醫療影像伺服器(UDE) APP” 曾獲得哪個獎項殊榮？</p>
                    <p class="at">愛迪生獎Edison Awards、國家新創獎 National Innovation Award、全球百大科技研發獎 R&D100Awards、國際新創獎 International Innovation Awards(IIA)</p>
                    <p class="qt">Q10: EBM在國內以下哪些縣市設有辦公室？</p>
                    <p class="at">臺北、臺中、高雄、花蓮</p>
                    <p class="qt">Q11: EBM客群分佈於以下哪些國家？</p>
                    <p class="at">台灣、日本、泰國、中國大陸</p>
                    <p class="qt">Q12: EBM新產品 “Family Health Record (FHR) APP” 所推廣的方向為何？</p>
                    <p class="at">個人行動醫療、家庭醫療影像管理、轉院光碟影像替代方案</p>
                    <p class="qt">Q13: EBM主要產品PACS目前已取得的認證為？</p>
                    <p class="at">美國食品藥物管理局FDA、歐洲合格認證CE、食品藥物管理局（台灣認證）TFDA</p>
                    <p class="qt">Q14: EBM 主要服務的客群對象為？</p>
                    <p class="at">醫療院所、中／小型診所、偏鄉衛生所</p>
                    <p class="qt">Q15: EBM目前全球已累積的客戶數量為？</p>
                    <p class="at">3,500</p>
                </div>
                <div class="b_button center" @click="gotoques">
                    <p class="b_text"> 回到活動頁面</p>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
export default {
    metaInfo() {
        return { 
            title: "UDE",
            meta: [
                { name: 'description', content:  'Server. Viewer. Display. AI All in one iPad'},
            ]
        }
    },
    methods:{
        gotoques(){
            this.$router.push("/udeevent");
        }
    }
}
</script>
<style scoped>
.app{
    width: 100%;
    height: 100%;
    background: black;
    color: white;
}
.v-application p{
    margin-bottom: 0px !important;
}
.hero_img {
  background-image: url("../assets/udeevent/udeevent_bg2.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.center{
    text-align: center;
}
.pt-32{
    padding-top: 32px;
}
.qt{
    padding-top: 36px;
    font-family: Raleway;
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 21px;
}
.at{
    padding-top: 16px;
    font-family: Raleway;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;
}
.pa-27{
    padding:27px;
}
.b_button{
    cursor: pointer;
    margin:auto;
    margin-top: 36px;
    margin-bottom: 36px;
    width: 236px;
    height: 48px;
    background: #00BEFF;
}
.b_text{
    font-family: Helvetica Neue;
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 29px;
padding-top: 10px;
color: #FFFFFF;
}

</style>